/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SplitHorizontalIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "split-horizontal", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.5 12.5H5.5V6.5H19.5V12.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 18.5H5.5V12.5H19.5V18.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SplitHorizontalIcon);
export default ForwardRef;
//# sourceMappingURL=splitHorizontalIcon.js.map